






























import { defineComponent, ref, computed } from '@vue/composition-api';
import type { PropType } from '@nuxtjs/composition-api';
import type { RelatedCategory } from '~/types/category/RelatedCategory';
import Link from '~/components/atoms/Link/Link.vue';
import { LinkType } from '~/types/components/Link/LinkType';
import { RELATED_CATEGORY_DISPLAY_LIMIT } from '~/constants/relatedCategory';

export default defineComponent({
  name: 'RelatedCategories',
  components: {
    Link,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    relatedCategories: {
      type: Array as PropType<RelatedCategory[]>,
      required: true,
    },
  },
  setup(props) {
    const isExpanded = ref(false);
    const isExpansionPossible = computed(() =>
      props.relatedCategories.length > RELATED_CATEGORY_DISPLAY_LIMIT,
    );
    const actionText = computed(() => isExpanded.value ? 'See less' : 'See more');
    const displayedCategories = computed(() => isExpanded.value
      ? props.relatedCategories
      : props.relatedCategories.slice(0, RELATED_CATEGORY_DISPLAY_LIMIT));

    const onClick = () => {
      isExpanded.value = !isExpanded.value;
    };

    return { isExpansionPossible, actionText, onClick, displayedCategories, LinkType };
  },
});
